import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/authContext";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Button, Spin, Statistic, Table, Tabs, Modal, Tooltip } from "antd";
import {
  LoadingOutlined,
  LockOutlined,
  QuestionCircleOutlined,
  ReloadOutlined,
  UnlockOutlined,
} from "@ant-design/icons";

import styles from "./wallet.module.scss";

import { getCustomerTransaction, getOrderPending } from "../../api";
import { formatPrice } from "../../utils/common";

import * as queryString from "query-string";

import i18n from "../../i18n";
import dayjs from "dayjs";

// const detailTranDes:any = {
//   'type': 'Loại giao dịch',
//   'created_by': 'Tạo bởi',
//   'created_at': 'Tạo lúc',
//   'source': 'Nguồn',
//   'payment_method': 'Phương thức thanh toán',
//   'bank': 'Ngân hàng',
//   'amount': 'Số tiền',
//   'penalty_amount': 'Số tiền bị phạt',
//   'total_amount': 'Tổng số tiền',
//   'wallet_amount': 'Số tiền sử dụng ví',
//   'status': 'Trạng thái',
//   'order_code': 'Mã đơn hàng',
//   'order_type': 'Loại đơn hàng',
//   'from': 'Người chuyển',
//   'to': 'Người nhận',
//   'from_user_id': 'ID người chuyển',
//   'to_user_id': 'ID người nhận',
//   'reason': 'Nội dung',
//   'use_wallet': 'Sử dụng ví',
//   'bank_short_name': 'Tên ngân hàng gửi',
//   'bank_number': 'Số tài khoản gửi'
// }

interface Props {
  customerWallet: any;
  handleChangeView: any;
}

const WalletOverview: React.FC<Props> = ({
  customerWallet,
  handleChangeView,
}) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const { search } = useLocation();
  const parseQuery = queryString.parse(search);
  const [walletLoading, setWalletLoading] = useState<boolean>(false);
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [transaction, setTransaction] = useState<any>([]);
  const [customerTransaction, setCustomerTransactionData] = useState<any>({
    data: [],
    pagination: {
      current: 1,
      pageSize: 5,
      total: 0,
    },
    loading: false,
  });
  const [pendingTransaction, setPendingTransaction] = useState<any>({
    data: [],
    pagination: {
      current: 1,
      pageSize: 5,
      total: 0,
    },
    loading: false,
  });

  useEffect(() => {
    fetchTransaction(1);
    fetchTransactionPending(1);
  }, []);

  useEffect(() => {
    if (parseQuery.lang && parseQuery.lang === "en") {
      i18n.changeLanguage(parseQuery.lang);
    } else {
      i18n.changeLanguage("vi");
    }
  }, [i18n]);

  const fetchTransaction = async (page: any) => {
    setCustomerTransactionData((prev: any) => ({
      ...prev,
      loading: true,
    }));

    // Transaction info
    const customerTransactionData = await getCustomerTransaction({
      page: page,
      pageSize: customerTransaction.pagination.pageSize,
    });

    if (customerTransactionData.status === "success") {
      setCustomerTransactionData((prev: any) => ({
        data: customerTransactionData.data.transactions,
        pagination: {
          ...prev.pagination,
          current: page,
          total: customerTransactionData.data.totalCount,
        },
      }));
    }

    setCustomerTransactionData((prev: any) => ({
      ...prev,
      loading: false,
    }));
  };

  const fetchTransactionPending = async (page: any) => {
    setPendingTransaction((prev: any) => ({
      ...prev,
      loading: true,
    }));

    // Transaction info
    const transactionPending = await getOrderPending({
      page: page,
      pageSize: pendingTransaction.pagination.pageSize,
    });

    if (transactionPending.status === "success") {
      setPendingTransaction((prev: any) => ({
        data: transactionPending.data.transactions,
        pagination: {
          ...prev.pagination,
          current: page,
          total: transactionPending.data.totalCount,
        },
      }));
    }

    setPendingTransaction((prev: any) => ({
      ...prev,
      loading: false,
    }));
  };

  async function handleTableChange(pagination: any) {
    await fetchTransaction(pagination.current);
  }

  async function handlePendingTableChange(pagination: any) {
    await fetchTransactionPending(pagination.current);
  }

  const columns = [
    {
      title: "ID",
      render: (text: any, record: any) => {
        if (record.entry.metadata) {
          return (
            <a
              type="link"
              className="text-blue-500 underline"
              onClick={() => {
                let arr = [];

                for (let i in record.entry.metadata) {
                  // @ts-ignore
                  arr.push([i, record.entry.metadata[i]]);
                }

                setTransaction(arr);
                setShowDetail(true);
              }}
            >
              {" "}
              {record.id}
            </a>
          );
        } else {
          return record.id;
        }
      },
    },
    {
      title: t("common:Ngày giao dịch"),
      render: (text: any, record: any) => {
        return dayjs(record.created_at).format("HH:mm | DD/MM/YYYY");
      },
    },
    // {
    //   title: t("common:Loại"),
    //   render: (text: any, record: any) => {
    //     const type = record?.entry?.audit_code?.split("-")[0];

    //     if (type === "DEPOSIT") {
    //       return t("common:Nạp");
    //     } else if (type === "WITHDRAW") {
    //       return t("common:Rút");
    //     } else if (type === "LOCK") {
    //       return t("common:Khóa");
    //     } else if (type === "UNLOCK") {
    //       return t("common:Mở khóa");
    //     } else if (type === "ORDER_PAYMENT") {
    //       return t("common:Thanh toán");
    //     } else if (type === "ORDER_REFUND") {
    //       return t("common:Hoàn tiền");
    //     } else if (type === "MOVE_MONEY") {
    //       return t("common:Chuyển tiền");
    //     }

    //     return t(type);
    //   },
    // },
    {
      title: t("common:Số tiền"),
      dataIndex: "created_at",
      render: (text: any, record: any) => {
        const type = record.audit_code_detail.split("-")[0];

        if (record.is_debit) {
          if (type === "LOCK" || type === "REWARD_LOCK") {
            return (
              <>
                <LockOutlined style={{ color: "#FA8C16" }} />
                <span> {formatPrice(record.debit_amount)}đ</span>
              </>
            );
          }
        } else {
          if (type === "UNLOCK" || type === "REWARD_UNLOCK") {
            return (
              <>
                <UnlockOutlined style={{ color: "#52C41A" }} />
                <span> {formatPrice(record.credit_amount)}đ</span>
              </>
            );
          }

          return (
            <span style={{ color: "#52C41A" }}>
              +{formatPrice(record.credit_amount)}đ
            </span>
          );
        }

        return (
          <span>
            {formatPrice(record.credit_amount - record.debit_amount)}đ
          </span>
        );
      },
    },
    {
      title: t("common:Trạng thái"),
      dataIndex: "created_at",
      render: (text: any, record: any) => {
        return (
          <span style={{ color: "#52C41A" }}>{t("common:Hoàn thành")}</span>
        );
      },
    },
    {
      title: t("common:Mô tả"),
      dataIndex: "created_at",
      render: (text: any, record: any) => {
        // let type = record.audit_code_detail.split("-")[0];
        // if (record?.audit_code_detail.indexOf("MOVE_MONEY") > -1) {
        //   type = "MOVE_MONEY";
        // }
        // if (record.is_debit) {
        //   if (type === "LOCK") {
        //     return t(type);
        //   }
        // } else {
        //   if (type === "UNLOCK") {
        //     return t(type);
        //   }
        // }

        // return t(type);
        return (
          <div>
            {record?.entry?.description}{" "}
            {String(record?.account?.code)?.startsWith("131-") &&
            String(record?.account?.code)?.endsWith("-REWARD")
              ? "(ví thưởng)"
              : ""}
          </div>
        );
      },
    },
  ];

  const pendingColumns = [
    {
      title: "ID",
      render: (text: any, record: any) => {
        return record.id;
      },
    },
    {
      title: t("common:Ngày giao dịch"),
      render: (text: any, record: any) => {
        return dayjs(record.created_at).format("HH:mm | DD/MM/YYYY");
      },
    },
    {
      title: t("common:Loại"),
      render: (text: any, record: any) => {
        const type = record.type;

        if (type === "topup") {
          return t("common:Nạp tiền");
        } else if (type === "hotel") {
          return t("common:Thanh toán khách sạn");
        } else if (type === "flight") {
          return t("common:Thanh toán vé máy bay");
        }

        return type;
      },
    },
    {
      title: t("common:Số tiền"),
      dataIndex: "created_at",
      render: (text: any, record: any) => {
        const type = record.type;

        // if (type === 'topuop') {
        //   if (type === 'LOCK') {
        //     return <><LockOutlined style={{color: '#FA8C16'}}/><span> {formatPrice(record.debit_amount)}</span></>
        //   }
        // }
        // else {
        //   if (type === 'UNLOCK') {
        //     return <><UnlockOutlined style={{color: '#52C41A'}}/><span> {formatPrice(record.credit_amount)}</span></>
        //   }
        //
        //   return <span style={{color: "#52C41A"}}>+{formatPrice(record.credit_amount)}</span>
        // }

        if (type !== "topup") {
          return <span>-{formatPrice(record.amount)}đ</span>;
        }

        return (
          <span style={{ color: "#52C41A" }}>
            +{formatPrice(record.amount)}đ
          </span>
        );
      },
    },
    {
      title: t("common:Trạng thái"),
      dataIndex: "created_at",
      render: (text: any, record: any) => {
        if (record.status === "order_pending_payment") {
          return <span>{t("common:Đang xử lý")}</span>;
        } else if (record.status === "order_fail") {
          return <span>{t("common:Đã hủy")}</span>;
        } else if (record.status === "order_pending_approve") {
          return <span>{t("common:Đang chờ xác nhận")}</span>;
        }

        return <span style={{ color: "#FA8C16" }}></span>;
      },
    },
    // {
    //   title: 'Thao tác',
    //   dataIndex: 'created_at',
    //   render: (text: any, record: any) => {
    //     return <a> Hủy </a>
    //   },
    // },
  ];

  if (walletLoading) {
    return (
      <Spin
        size="large"
        indicator={<LoadingOutlined spin />}
        style={{ width: "100%" }}
      />
    );
  }

  const handleCancel = () => {
    setShowDetail(false);
  };

  const rewardToolip = () => {
    let tooltip = "";
    switch (auth?.user?.business_role) {
      case "agency":
        tooltip =
          "Số dư tiền thưởng bạn được phép chuyển sang ví chính để sử dụng thanh toán đơn hàng khi đạt đủ 1.000.000đ. Vui lòng liên hệ hỗ trợ khi đạt đủ 1.000.000đ";
        break;
      case "general_agency":
        tooltip =
          "Số dư tiền thưởng bạn được phép chuyển sang ví chính để sử dụng thanh toán đơn hàng khi đạt đủ 1.500.000đ. Vui lòng liên hệ hỗ trợ khi đạt đủ 1.500.000đ";
        break;
      default:
        tooltip =
          "Số dư tiền thưởng bạn được phép chuyển sang ví chính để sử dụng thanh toán đơn hàng khi đạt đủ 500.000đ. Vui lòng liên hệ hỗ trợ khi đạt đủ 500.000đ";
        break;
    }
    return tooltip;
  };

  return (
    <>
      <Modal
        title={t("common:Chi tiết giao dịch")}
        visible={showDetail}
        onCancel={handleCancel}
        footer={false}
      >
        {transaction.map((ele: any) => {
          return (
            <div key={ele}>
              {t(`common:${ele[0]}`)}{" "}
              <span style={{ float: "right" }}>{t(`common:${ele[1]}`)}</span>
            </div>
          );
        })}
      </Modal>

      <Tabs
        defaultActiveKey="1"
        style={{
          borderRadius: "8px",
          padding: "0 16px 16px 16px",
          marginBottom: "16px",
          backgroundColor: "white",
        }}
        className="shadow"
      >
        <Tabs.TabPane tab={t("common:Thông tin ví")} key="1">
          <p className="walletAccountId mb-16">
            {t("common:Số tài khoản")}:&nbsp;
            <span className="font-medium">{"ATD" + customerWallet.userId}</span>
          </p>
          <div className="flex items-center justify-between gap-16 flex-wrap">
            <Statistic
              title={
                <Tooltip
                  title={t(
                    "common:Tổng số tiền có thể sử dụng để thanh toán đơn hàng"
                  )}
                >
                  <span>
                    {t("common:Tổng số dư khả dụng")}{" "}
                    <QuestionCircleOutlined style={{ color: "#8c8c8c" }} />
                  </span>
                </Tooltip>
              }
              value={customerWallet.totalMainWalletBalance}
              suffix="đ"
              groupSeparator={"."}
              className={styles.walletTransaction}
              valueStyle={{ fontSize: "20px" }}
            />

            <Statistic
              title={
                <Tooltip title={<span>{rewardToolip()}</span>}>
                  <span>
                    {t("common:Số dư thưởng")}{" "}
                    <QuestionCircleOutlined style={{ color: "#8c8c8c" }} />
                  </span>
                </Tooltip>
              }
              value={customerWallet.totalRewardBalance}
              suffix="đ"
              groupSeparator={"."}
              className={styles.walletTransaction}
              valueStyle={{ fontSize: "20px" }}
            />

            {customerWallet?.totalMainWalletLockedBalance > 0 ? (
              <Statistic
                title={
                  <Tooltip title={t("common:Tổng số tiền bị khóa")}>
                    <span>
                      {t("common:Số dư bị khóa")}{" "}
                      <QuestionCircleOutlined style={{ color: "#8c8c8c" }} />
                    </span>
                  </Tooltip>
                }
                value={customerWallet.totalMainWalletLockedBalance}
                suffix="đ"
                groupSeparator={"."}
                className={styles.walletTransaction}
                valueStyle={{ fontSize: "20px" }}
              />
            ) : null}

            <div className="flex gap-16 h-full items-end w-full xl:w-fit xl:self-end">
              {/* <div>
                <Button type="default">{t("common:Yêu cầu rút tiền")}</Button>
              </div> */}
              <div
                className={styles.walletFormItem}
                style={{ marginRight: "0" }}
              >
                <Button
                  type="primary"
                  onClick={() => {
                    handleChangeView("deposit");
                  }}
                >
                  {t("common:Nạp tiền vào ví")}
                </Button>
              </div>
            </div>
          </div>
        </Tabs.TabPane>
      </Tabs>

      <Tabs
        defaultActiveKey="1"
        style={{
          borderRadius: "8px",
          padding: "0 16px 16px 16px",
          marginBottom: "16px",
          backgroundColor: "white",
        }}
        className="shadow"
        // tabBarExtraContent={
        //   <RangePicker />
        // }
        tabBarExtraContent={
          <ReloadOutlined
            style={{ color: "#FA8C16" }}
            onClick={() => {
              fetchTransaction(1);
            }}
          />
        }
      >
        <Tabs.TabPane tab={t("common:Lịch sử giao dịch")} key="1">
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={customerTransaction.data}
            pagination={{
              current: customerTransaction.pagination.current,
              pageSize: customerTransaction.pagination.pageSize,
              total: customerTransaction.pagination.total,
              showSizeChanger: false,
            }}
            loading={customerTransaction.loading}
            onChange={handleTableChange}
            size="small"
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t("common:Đang xử lý")} key="2">
          <Table
            columns={pendingColumns}
            rowKey={(record) => record.id}
            dataSource={pendingTransaction.data}
            pagination={{
              current: pendingTransaction.pagination.current,
              pageSize: pendingTransaction.pagination.pageSize,
              total: pendingTransaction.pagination.total,
              showSizeChanger: false,
            }}
            loading={pendingTransaction.loading}
            onChange={handlePendingTableChange}
            size="small"
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default WalletOverview;
